import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-page-spinner',
  templateUrl: './page-spinner.component.html',
  styleUrls: ['./page-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIPageSpinnerComponent {}
